import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      toast.error(`Microsoft login failed: ${error}`);
      navigate("/login", { replace: true });
      return;
    }

    if (!code) {
      toast.error("Missing exchange code");
      navigate("/login", { replace: true });
      return;
    }

    // Relative path — the exchange code itself isn't cookie-bound, but kept
    // same-origin for consistency with the login redirect above.
    fetch(`/api/auth/azure/exchange/${code}`)
      .then((r) => {
        if (!r.ok) throw new Error("Exchange failed");
        return r.json();
      })
      .then((data) => {
        loginWithToken(data.access_token, data.user);
        toast.success(`Welcome, ${data.user.display_name || data.user.email}!`);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in exchange failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [params, loginWithToken, navigate]);

  return (
    <div className="min-h-screen bg-[#0A6755] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-[#6EDD5B] border-t-transparent rounded-full animate-spin" />
        <p className="text-white/80 text-sm font-mono">Completing Microsoft sign-in…</p>
      </div>
    </div>
  );
}
